 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import BACK_COVER_TEXT from '@/components/Back_Cover_Text'
 import INTRODUCTION from '@/components/Introduction'
 import DEAR_READER from '@/components/Dear_Reader'
 import LOVE_1 from '@/components/love_1'
 import TITLE_PAGE from '@/components/Title_Page'
 import ABOUT_THE_AUTHOR from '@/components/About_the_Author'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import CHAPTER_1 from '@/components/Chapter_1'
 import CHAPTER_2 from '@/components/Chapter_2'
 import CHAPTER_3 from '@/components/Chapter_3'
 import CHAPTER_4 from '@/components/Chapter_4'
 import CHAPTER_5 from '@/components/Chapter_5'
 import CHAPTER_6 from '@/components/Chapter_6'
 import CHAPTER_7 from '@/components/Chapter_7'
 import CHAPTER_8 from '@/components/Chapter_8'
 import CHAPTER_9 from '@/components/Chapter_9'
 import CHAPTER_10 from '@/components/Chapter_10'
 import CHAPTER_11 from '@/components/Chapter_11'
 import CHAPTER_12 from '@/components/Chapter_12'
 import CHAPTER_13 from '@/components/Chapter_13'
 import CHAPTER_14 from '@/components/Chapter_14'
 import CHAPTER_15 from '@/components/Chapter_15'
 import CHAPTER_16 from '@/components/Chapter_16'
 import CHAPTER_17 from '@/components/Chapter_17'
 import CHAPTER_18 from '@/components/Chapter_18'
 import CHAPTER_19 from '@/components/Chapter_19'
 import CHAPTER_20 from '@/components/Chapter_20'
 import CHAPTER_21 from '@/components/Chapter_21'
 import CHAPTER_22 from '@/components/Chapter_22'
 import CHAPTER_23 from '@/components/Chapter_23'
 import CHAPTER_24 from '@/components/Chapter_24'
 import CHAPTER_25 from '@/components/Chapter_25'
 import CHAPTER_26 from '@/components/Chapter_26'
 import LOVE_2 from '@/components/love_2'
 import BPAROMANTIC_SUSPENSE from '@/components/BPARomantic_Suspense'
 import BPAMYREWARDS from '@/components/BPAMyRewards'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Chapter_1",
 			"name" : "Chapter_1",
 			"component" : CHAPTER_1
 		},
 		{
 			"path" : "/Chapter_2",
 			"name" : "Chapter_2",
 			"component" : CHAPTER_2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js